import Vue from 'vue'
import { REMOTE_PATHS } from '@/constants/remote-paths.constant'
import { refreshAccessToken } from '@/store/oauth/api.js'

/**
 * Mutable refresh access token promise
 * To ensure there is only one token request
 */
let refreshAccessTokenPromise

function checkForAuthToken () {
  const token = Vue.prototype.$cookie.get('accessToken')
  if (token) {
    return Promise.resolve()
  }

  if (refreshAccessTokenPromise) {
    return refreshAccessTokenPromise
  }

  refreshAccessTokenPromise = new Promise((resolve, reject) => {
    return refreshAccessToken()
      .then(() => {
        refreshAccessTokenPromise = undefined
        resolve()
      })
      .catch((err) => {
        refreshAccessTokenPromise = undefined
        reject(err)
      })
  })
  return refreshAccessTokenPromise
}

const headers = ({ withAuthorization = true }) => {
  const headers = {
    Accept: 'application/x-protobuf',
    'Content-Type': 'application/x-protobuf'
  }
  const token = withAuthorization ? Vue.cookie.get('accessToken') : undefined
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  return headers
}

const constructPath = (path, base, kingsChat) => {
  if (base) {
    return `${base}${path}`
  }
  if (kingsChat) {
    return `${REMOTE_PATHS.API_PATH}${path}`
  }
  return `${REMOTE_PATHS.CLOUD_API_PATH}${path}`
}

const requestBuilder = {
  get ({ path, params, base, kingsChat, withAuthorization = true }) {
    if (!withAuthorization) {
      return Vue.http.get(constructPath(path, base, kingsChat), {
        params: params,
        headers: headers({ withAuthorization }),
        responseType: 'arraybuffer'
      })
    }
    return checkForAuthToken()
      .then(() => {
        return Vue.http.get(constructPath(path, base, kingsChat), {
          params: params,
          headers: headers({ withAuthorization }),
          responseType: 'arraybuffer'
        })
      })
  },
  post ({ path, body, base, kingsChat, withAuthorization = true }) {
    if (!withAuthorization) {
      return Vue.http.post(constructPath(path, base, kingsChat), body, {
        headers: headers({ withAuthorization }),
        responseType: 'arraybuffer'
      })
    }
    return checkForAuthToken()
      .then(() => {
        return Vue.http.post(constructPath(path, base, kingsChat), body, {
          headers: headers({ withAuthorization }),
          responseType: 'arraybuffer'
        })
      })
  },
  put ({ path, body, base, kingsChat, withAuthorization = true }) {
    if (!withAuthorization) {
      return Vue.http.put(constructPath(path, base, kingsChat), body, {
        headers: headers({ withAuthorization }),
        responseType: 'arraybuffer'
      })
    }
    return checkForAuthToken()
      .then(() => {
        return Vue.http.put(constructPath(path, base, kingsChat), body, {
          headers: headers({ withAuthorization }),
          responseType: 'arraybuffer'
        })
      })
  },
  patch ({ path, body, base, kingsChat, withAuthorization = true }) {
    if (!withAuthorization) {
      return Vue.http.patch(constructPath(path, base, kingsChat), body, {
        headers: headers({ withAuthorization }),
        responseType: 'arraybuffer'
      })
    }
    return checkForAuthToken()
      .then(() => {
        return Vue.http.patch(constructPath(path, base, kingsChat), body, {
          headers: headers({ withAuthorization }),
          responseType: 'arraybuffer'
        })
      })
  },
  delete ({ path, base, kingsChat, withAuthorization = true }) {
    if (!withAuthorization) {
      return Vue.http.delete(constructPath(path, base, kingsChat), {
        headers: headers({ withAuthorization }),
        responseType: 'arraybuffer'
      })
    }
    return checkForAuthToken()
      .then(() => {
        return Vue.http.delete(constructPath(path, base, kingsChat), {
          headers: headers({ withAuthorization }),
          responseType: 'arraybuffer'
        })
      })
  }
}

export default requestBuilder
